/**
 * Sidebar Product Panel - Event Handlers
 * Uses document-level event delegation so it works with SPA navigation
 */
(function() {
  'use strict';

  // Retailer selection - document-level delegation
  document.addEventListener('click', function(e) {
    var row = e.target.closest('[data-retailer-row]');
    if (!row) return;

    var retailerList = row.closest('[data-retailer-list]');
    if (!retailerList) return;

    // Remove active from all retailers in this list
    retailerList.querySelectorAll('[data-retailer-row]').forEach(function(r) {
      r.classList.remove('sp-retailer--active');
    });

    // Add active to clicked
    row.classList.add('sp-retailer--active');

    // Update shop button
    var panel = row.closest('[data-product-panel]');
    if (panel) {
      var shopButton = panel.querySelector('[data-shop-button]');
      if (shopButton && row.dataset.retailerUrl) {
        shopButton.href = row.dataset.retailerUrl;
        shopButton.textContent = 'Shop from ' + row.dataset.retailerName;
      }
    }
  });

  // Track outbound retailer clicks (GA4)
  document.addEventListener('click', function(e) {
    var shopBtn = e.target.closest('[data-shop-button], .btn-shop');
    if (!shopBtn) return;

    var url = shopBtn.href || shopBtn.dataset.retailerUrl;
    if (!url || url.indexOf(window.location.host) !== -1) return;

    // GA4 event
    if (typeof gtag === 'function') {
      gtag('event', 'retailer_click', {
        retailer_url: url,
        retailer_name: shopBtn.textContent.replace('Shop from ', '').trim(),
        product_title: document.querySelector('.sp-title__name, .mobile-product-details__full-title') ?
          document.querySelector('.sp-title__name, .mobile-product-details__full-title').textContent.trim() : '',
        outbound: true
      });
    }
  });

  // Region selection - document-level delegation
  document.addEventListener('click', function(e) {
    var regionBtn = e.target.closest('.sp-region[data-region]');
    if (!regionBtn) return;

    var regionsContainer = regionBtn.closest('.sp-regions');
    if (!regionsContainer) return;

    regionsContainer.querySelectorAll('.sp-region[data-region]').forEach(function(b) {
      b.classList.remove('sp-region--active');
    });
    regionBtn.classList.add('sp-region--active');
  });

  // Back button - document-level delegation
  document.addEventListener('click', function(e) {
    if (e.target.closest('[data-product-back]')) {
      e.preventDefault();
      window.history.back();
    }
  });

  // Close button - document-level delegation
  document.addEventListener('click', function(e) {
    if (e.target.closest('[data-product-close]')) {
      e.preventDefault();
      if (window.SPA) {
        window.SPA.navigateTo('/collections/sneakers', 'collection');
      } else {
        window.location.href = '/collections/sneakers';
      }
    }
  });

  // Wishlist button initialization
  function initWishlistButtons() {
    document.querySelectorAll('[data-wishlist-add]').forEach(function(btn) {
      if (btn.dataset.wishlistInit === 'true') return;
      btn.dataset.wishlistInit = 'true';

      var handle = btn.dataset.wishlistAdd;
      if (window.Wishlist && window.Wishlist.isInWishlist(handle)) {
        btn.classList.add('sp-btn--active');
        btn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg> Saved';
      }
    });
  }

  // Initialize wishlist buttons on load
  initWishlistButtons();

  // Re-initialize wishlist buttons when DOM changes (for SPA)
  if (window.MutationObserver) {
    var observer = new MutationObserver(function() {
      initWishlistButtons();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  // Also handle SPA navigation events
  document.addEventListener('spa:navigate', function() {
    setTimeout(initWishlistButtons, 100);
  });
})();
